"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnseatedFlexCartItemsBase = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_redux_1 = require("react-redux");
var unseated_flex_cart_items_view_1 = tslib_1.__importDefault(require("unseated-flex-cart-items.view"));
var UnseatedFlexCartItemsBase = /** @class */ (function (_super) {
    tslib_1.__extends(UnseatedFlexCartItemsBase, _super);
    function UnseatedFlexCartItemsBase(props) {
        return _super.call(this, props) || this;
    }
    UnseatedFlexCartItemsBase.prototype.render = function () {
        return React.createElement(unseated_flex_cart_items_view_1.default, tslib_1.__assign({}, this.props, this.state));
    };
    return UnseatedFlexCartItemsBase;
}(React.Component));
exports.UnseatedFlexCartItemsBase = UnseatedFlexCartItemsBase;
function mapStateToProps(state, ownProps) {
    return {
        requiresPerformanceGroups: ownProps.performanceGroups.length > 1
            && ownProps.performanceGroups
                .filter(function (pg) { return pg.minimumPerformances > 0 ||
                (pg.maximumPerformances > 0 && pg.maximumPerformances != ownProps.packageMax); }).length > 0,
        text: state.packageListingText,
        cartItems: state.packageListing.cartItems,
        itemsInCart: state.packageListing.cartItems.length,
    };
}
function mapDispatchToProps(dispatch, ownProps) {
    return {};
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UnseatedFlexCartItemsBase);
//# sourceMappingURL=unseated-flex-cart-items.js.map